export default __webpack_public_path__ + "static/reauth_onboard-3cffcea449a663ae0b0615c0d22d77f2.svg";